import React, { useState } from "react"
import { Row, Col } from "react-bootstrap"
import * as API from "../../../services/httpService"
import { useSelector, shallowEqual } from "react-redux"
import FeedbackForm from "../../shared/feedback/feedbackForm"

const SubmittedClaim = React.memo(({ uiData }) => {
  const claimData = useSelector(state => state.claimData, shallowEqual)
  const [
    feedbackWhereKnowAboutUsList,
    setFeedbackWhereKnowAboutUsList,
  ] = useState([])

  React.useEffect(() => {
    //Get feedback know about us list
    API.apiPostRequest("/Claim/CommonDropDownList", null, {
      params: {
        name: "FEEDBACK_WHERE_KNOW_ABOUT_US",
      },
    }).then(response => {
      setFeedbackWhereKnowAboutUsList(response.data.CodeTables)
    })
  }, [])

  //Prevent email optional field no value
  if (claimData.claimInfo.policyInfo.claimantEmail == "") {
    claimData.claimInfo.policyInfo.claimantEmail = "no_email@etiqa.com.sg"
  }

  let feedbackFormProps = {
    customerName: claimData.claimInfo.policyInfo.policyHolderName,
    customeEmail: claimData.claimInfo.policyInfo.claimantEmail,
    orderRef: uiData.submittedResult.claimID,
    productName: uiData.claimFormTitle,
    productSearchCode: claimData.claimInfo.claimAttributeModel.productType,
    campaign: "Claims",
    salesChannel: claimData.claimInfo.policyInfo.sourceSystem,
    feedbackWhereKnowAboutUsList: feedbackWhereKnowAboutUsList,
  }

  return (
    <Row className={"MarginTop75 " + (uiData.pageNumber === 6 ? "" : "hide")}>
      <Col xs={12} className="submittedContainerBody marginTop3x">
        <Col xs={12} md={12}>
          <div className="title text-center">
            Your Windscreen Claim is Successfully Submitted
          </div>
          <Col md={12}>
            <Col xs={12} md={12} className="form-group green2 text-center">
              <div className="paymentIcon rounded"></div>
            </Col>

            <label className="receiveClaimLabel mt-3">
              We have received your windscreen claim submission. An automated
              confirmation will be sent to your registered email
            </label>

            <div className="submitResultBorder">
              <span>Claim ID</span>
              <br />
              <span className="submitResultBorderResult">
                {uiData.submittedResult.claimID}
              </span>
            </div>
          </Col>
        </Col>
      </Col>

      <Col xs={12} className="submittedContainerBody marginTop3x tiqAppBanner">
        <Col xs={12} md={12}>
          <Row>
            <Col xs={0} md={2}></Col>
            <Col xs={4} md={2}>
              <Row>
                <Col className="text-center MarginTop15">
                  <Col className="tiqAppQrCode"></Col>
                </Col>
              </Row>
              <Row>
                <Col className="tiqAppBannerText text-center MarginBottom15">
                  <b>Tiq by Etiqa app</b>
                </Col>
              </Row>
            </Col>

            <Col xs={8} md={6} className="MarginBottom15">
              <Row>
                <Col className="tiqAppBannerText MarginTop15">
                  <b>Track Claims Easily</b> <br />
                  Download Tiq by Etiqa app and login to start tracking your
                  claims with ease.
                </Col>
              </Row>
              <Row>
                <Col xs={2} md={2} className="text-center">
                  <Col className="tiqAppIcon"></Col>
                </Col>
                {/* <Col xs={0} md={0} className="">
                </Col> */}
                <Col xs={5} md={4} className="text-center">
                  <Col className="appStoreIcon"></Col>
                </Col>
                {/* <Col xs={0} md={1} className="">
                </Col> */}
                <Col xs={5} md={4} className="text-center">
                  <Col className="playStoreIcon"></Col>
                </Col>
                <Col xs={0} md={2} className=""></Col>
              </Row>
            </Col>
            <Col xs={0} md={2}></Col>
          </Row>
        </Col>
      </Col>

      <Col xs={12} className="submittedContainerBody marginTop3x">
        <Col xs={12} md={12} className="text-center">
          <FeedbackForm {...feedbackFormProps} />
        </Col>
      </Col>

      <Col xs={12} className="submittedContainerBody marginTop3x">
        <Col xs={12} md={12} className="text-center">
          <p className="mt-4">
            <span className="customerCareTitle">
              Customer Care operating hours:
            </span>
            <span className="customerCareText1">
              Monday to Friday, 8:45am to 5:30pm, excluding saturday, sunday and
              public holidays
            </span>
          </p>
          <p>
            <span className="customerCareTitle">
              <span className="fa fa-envelope-o"></span> Email:
            </span>
            <span className="customerCareText2">
              <u>customer.service@etiqa.com.sg</u>
            </span>
          </p>
          <p className="mb-4">
            <span className="customerCareTitle">
              <span className="fa fa-whatsapp"></span> Whatsapp:
            </span>
            <span className="customerCareText2">+65 68878777</span>
          </p>
        </Col>
      </Col>
    </Row>
  )
})
export default SubmittedClaim
